const enquiryContent = {
  product: ['Ask about product availability, specifications, compatibility, sizing or an existing order.', 'Enquiry', 'Send Product Enquiry'],
  coaching: ['Ask about finding a coach, booking a lesson, a coaching account or an existing class.', 'Enquiry', 'Send Coaching Enquiry'],
  coach: ['Ask about eligibility, verification, pricing or the coach onboarding process.', 'Enquiry', 'Ask About Coach Registration'],
  academy: ['Request a platform demo or discuss academy listing, migration, plans and implementation.', 'Requirements', 'Request an Academy Demo'],
  holiday: ['Share preferred destinations, dates, group size, rounds and accommodation preferences.', 'Requirements', 'Request a Golf Itinerary'],
  corporate: ['Discuss group travel, client programmes, leadership retreats, tournaments or hospitality.', 'Requirements', 'Discuss Corporate Golf Travel'],
  general: ['Use this option when your request does not fit the categories above.', 'Message', 'Contact Support']
};

document.querySelectorAll('.contact-hub__form--adaptive').forEach((form) => {
  const select = form.querySelector('[data-enquiry-select]');
  const fields = form.querySelector('[data-base-fields]');
  const help = form.querySelector('[data-enquiry-help]');
  const button = form.querySelector('[data-submit-button]');
  const personName = form.querySelector('[data-person-name]');
  const companyName = form.querySelector('[data-company-name]');
  const academyName = form.querySelector('[data-academy-name]');
  const contactName = form.querySelector('[data-contact-name]');

  const update = () => {
    const type = select.value;
    const content = enquiryContent[type];
    fields.hidden = !content;
    button.hidden = !content;
    help.textContent = content ? content[0] : 'Please select an enquiry type to continue.';
    form.querySelectorAll('[data-for]').forEach((field) => { field.hidden = field.dataset.for !== type; });
    personName.hidden = type === 'academy' || type === 'corporate';
    companyName.hidden = type !== 'corporate';
    academyName.hidden = type !== 'academy';
    contactName.hidden = type !== 'academy' && type !== 'corporate';
    [personName, companyName, academyName, contactName].forEach((label) => { const input = label.querySelector('input'); input.required = !label.hidden; });
    if (content) { form.querySelector('[data-message-label]').textContent = content[1]; button.textContent = content[2]; }
  };
  select.addEventListener('change', update);
  update();
});

const hideFloatingCaptchaBadge = () => {
  document.querySelectorAll('iframe[src*="hcaptcha"], iframe[title*="hCaptcha"], iframe[title*="hcaptcha"]').forEach((frame) => {
    const rect = frame.getBoundingClientRect();
    if (rect.width > 140 || rect.height > 140) return;

    let target = frame;
    let parent = frame.parentElement;
    while (parent && parent !== document.body) {
      const position = getComputedStyle(parent).position;
      if (position === 'fixed') {
        target = parent;
        break;
      }
      parent = parent.parentElement;
    }
    target.style.setProperty('display', 'none', 'important');
    target.setAttribute('aria-hidden', 'true');
  });
};

hideFloatingCaptchaBadge();
new MutationObserver(hideFloatingCaptchaBadge).observe(document.body, { childList: true, subtree: true });
